// Centralized site copy. Edit strings here rather than searching across
// the codebase. New copy added during the J1 branding refresh (Phase J,
// 2026-06-07) goes under HOMEPAGE; legacy strings get migrated here as
// they're encountered in subsequent sprints.

export const HOMEPAGE = {
  HERO_TAGLINE: "Find It. Claim It. Lock It.",
  HERO_SUBHEAD: "Every home has a history. Make yours work for you.",
  HERO_SUPPORTING_TOP: "Unlock the power to",
  HERO_SUPPORTING_BOTTOM: "manage your home hassle free.",
  PRIMARY_CTA: "Claim Your Home",
  HERO_REPORT_CTA: "See Sample Home History Report",
  HERO_REPORT_URL: "/sample-home-history-report.pdf",
  HERO_FEATURES: [
    { top: "Repairs", bottom: "& Upgrades" },
    { top: "Warranties", bottom: "& Manuals" },
    { top: "Permits", bottom: "& Inspections" },
    { top: "Boost", bottom: "Resale Value" },
  ],
} as const;

// Lock It 5 homepage — "Home History" 3-step section (below the hero).
// Images live in /public and are referenced by URL.
export const HOME_HISTORY_STEPS = {
  STEPS: [
    { num: 1, img: "/step1.png", title: "We find what already exists.", body: "Permits and available public property records." },
    { num: 2, img: "/step2.png", title: "You build what happens next.", body: "Repairs, improvements, warranties and inspections." },
    { num: 3, img: "/step3.png", title: "Your home history stays with the home.", body: "A useful record today — and when it's time to sell." },
  ],
} as const;

// Phase J3: rights-agreement text shown to the user in the claim modal.
// Must stay in sync with backend/src/constants/legalText.js
// (CLAIM_RIGHTS_AGREEMENT). The backend snapshots the SERVER copy of the
// text into each ApnDocument — this client copy is purely cosmetic.
export const CLAIM = {
  RIGHTS_AGREEMENT_LABEL:
    "I am the legal owner of this property, or I am authorized by the " +
    "owner to act on their behalf. I understand SimplerHome relies on " +
    "this declaration to grant me management access, and that " +
    "misrepresentation may result in loss of access and removal of " +
    "submitted content.",
  RIGHTS_AGREEMENT_CHECKBOX_HINT: "I agree to the statement above.",
} as const;

export const THREE_STEPS = {
  HEADING: "How SimplerHome Works",
  STEPS: [
    {
      key: "find",
      title: "Find It",
      body: "Search by address to pull up your home from public property records.",
    },
    {
      key: "claim",
      title: "Claim It",
      body: "Prove ownership with a single document upload and start managing your home.",
    },
    {
      key: "lock",
      title: "Lock It",
      body: "Claim your home to unlock private management — documents, maintenance, and insurance, all in one place.",
    },
  ],
} as const;
